module.exports = __webpack_public_path__ + "static/media/warehouse-alt.c769d20b.svg";